import React from "react";
import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import VitalForm from "./VitalForm";
import { patientDetail } from "store/slice/patient-detail-slice";
import utils from "utils";
import "./VitalForm.scss";
function VitalFormDoctorAtConsultation(props) {
//   const location = useLocation();
//   const history = useHistory();
//   const patientDetails = location?.patientDetails || props.patient_id;
const patientDetails = props?.data;
//   props.patientDetail(patientDetails);
  return (
    <div >
      <VitalForm  formAction={props.formAction}
              patientDetails={patientDetails} />
    </div>
  );
}

// const mapStateToProps = (state) => {
//   return {
//     user_details: state.loginReducer?.user_details,
//     patient_id: state.patientDetailReducer.patient_detail,
//   };
// };
// const mapDispatchToProps = {
//   patientDetail,
// };
// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(VitalFormDoctorAtConsultation);
export default VitalFormDoctorAtConsultation;
